<template>
    <div class="games-card">
        <div class="user-list" :class="item_game">
          <v-list color="transparent" class="pa-0" v-if="matches.user">
            <v-list-item class="pa-0">
                <span v-if="index == 0" class="number-rating number-rating--first">{{index +1}}</span>
                <span v-else-if="index == 1" class="number-rating number-rating--second">{{index +1}}</span>
                <span v-else-if="index == 2" class="number-rating number-rating--third">{{index +1}}</span>
                <span v-else class="number-rating">{{index +1}}</span>
              <div class="block-img" :class="(matches.user.pro) ? 'user-pro-img' : ''">
                <router-link :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                  <div class="wrap-img">
<!--                    <img :src="'/assets/users/'+((matches.user.photo) ? matches.user.photo : 'a-default.svg')"/>-->
                      <img v-if="matches.user.photo && typeof matches.user.photo == 'object'" :src="matches.user.photo[40]"/>
                      <img v-else-if="matches.user.photo" :src="matches.user.photo"/>
                      <span v-else class="photo" :style="{'background': matches.user.bg_color}">{{matches.user.name.substr(0,1)}}</span>
                  </div>
                  <div v-if="now_date < date" class="online"></div>
                </router-link>
              </div>
              <v-list-item-content class="person-info pa-0">
                <v-list-item-title>
                  <router-link :class="(matches.user.pro) ? 'user-pro' : ''" :to="{name: 'profile', params: {id: matches.user.public_id, lang: $store.getters.getLang}}" >
                    {{matches.user.name+" "+((matches.user.last_name) ? matches.user.last_name : '')}}
                  </router-link>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <img class="ml-0 mr-1" height="12px" src="/dist/images/frontend/fire.svg" alt />
                  <span style="color: #F6A401" class="mr-2">{{matches.user.rating_points}}</span>
                  <span style="color: #96AFD1">
                    <img width="14" :src="matches.user.location_img" />
                    {{$getLocation(matches.user.location)}}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list color="transparent" v-else class="pa-0">
            <v-list-item class="pa-0">
              <div class="block-img-game">
                <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                  <div class="wrap-img-game">
                      <img v-if="typeof game.logo == 'object'" :src="game.logo[100]">
                      <img v-else :src="game.logo">
                  </div>
                </router-link>
              </div>
              <v-list-item-content class="person-info pa-0">
                <v-list-item-title>
                  <router-link :to="{name: 'game', params: {id: game.url, lang: $store.getters.getLang}}">
                    {{game.name}}
                  </router-link>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div class="d-flex rating">
                    <div class="d-flex">
                      <span>{{game.rating}}</span>
                      <v-rating
                        :value="Number(game.rating)"
                        background-color="grey darken-1"
                        color="blue lighten-1"
                        readonly
                        dense
                        size="18"
                        class="mr-2"
                      ></v-rating>
                    </div>
<!--                      <router-link :to="{name: 'profile', params: {id: game.developer.id}}">-->
<!--                          {{game.developer.name+" "+((game.developer.last_name) ? game.developer.last_name : '')}}-->
<!--                      </router-link>-->
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div class="block-game-rating">
            <span>{{matches.rating}}</span>
            <svg width="13" height="16" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.95934 5.20937C9.84634 5.97544 10.3536 6.91473 10.3536 8.2029C10.3536 10.8867 8.25684 13 5.68354 13C3.10792 13 1 10.8852 1 8.2029C1 6.72566 1.32012 5.81269 2.25983 4.29517C2.55718 3.81498 3.27917 3.98985 3.33511 4.5556C3.38538 5.06396 3.53971 5.49668 3.76458 5.82843C3.6146 4.03581 4.39287 2.01974 6.31188 1.06194C6.75616 0.840199 7.25192 1.24817 7.13632 1.74039C6.83672 3.01601 7.14541 3.70229 7.95231 4.44161C7.97199 4.45964 8.07251 4.53385 8.20547 4.63201C8.44624 4.80977 8.79338 5.06604 8.95934 5.20937ZM2.5321 6.26567C2.36737 6.64916 2.16921 7.11049 2.16921 8.20284C2.16921 10.218 3.74826 11.8022 5.68354 11.8022C7.61532 11.8022 9.18443 10.2207 9.18443 8.20284C9.18443 7.3026 8.84807 6.6798 8.2057 6.12502C8.10431 6.03745 7.86664 5.86065 7.64293 5.69424C7.43142 5.53689 7.23239 5.38884 7.17284 5.33427C6.39817 4.62448 5.92457 3.86864 5.86024 2.86077C5.46856 3.2519 4.56855 4.46785 5.07583 6.87425C5.15447 7.24731 4.87697 7.59952 4.5044 7.59952C3.7652 7.59952 3.03451 7.02042 2.58794 6.13394C2.57002 6.17737 2.55129 6.22099 2.5321 6.26567Z" fill="#00C443"/>
                <path d="M8.95934 5.20937L8.89398 5.28506L8.95934 5.20937ZM2.25983 4.29517L2.17481 4.24252L2.25983 4.29517ZM3.33511 4.5556L3.43463 4.54576L3.33511 4.5556ZM3.76458 5.82843L3.68181 5.88454L3.89608 6.20065L3.86424 5.82009L3.76458 5.82843ZM6.31188 1.06194L6.26722 0.97247V0.97247L6.31188 1.06194ZM7.13632 1.74039L7.23367 1.76325L7.13632 1.74039ZM7.95231 4.44161L7.88475 4.51534H7.88475L7.95231 4.44161ZM8.20547 4.63201L8.26486 4.55156L8.20547 4.63201ZM2.5321 6.26567L2.62398 6.30513L2.5321 6.26567ZM8.2057 6.12502L8.14034 6.2007H8.14034L8.2057 6.12502ZM7.64293 5.69424L7.58325 5.77447L7.58325 5.77447L7.64293 5.69424ZM7.17284 5.33427L7.24039 5.26054L7.17284 5.33427ZM5.86024 2.86077L5.96004 2.8544L5.94596 2.63385L5.78958 2.79001L5.86024 2.86077ZM5.07583 6.87425L4.97798 6.89488L4.97798 6.89488L5.07583 6.87425ZM2.58794 6.13394L2.67725 6.08895L2.57887 5.89367L2.49549 6.09581L2.58794 6.13394ZM10.4536 8.2029C10.4536 6.88264 9.9313 5.91668 9.0247 5.13369L8.89398 5.28506C9.76139 6.0342 10.2536 6.94682 10.2536 8.2029H10.4536ZM5.68354 13.1C8.31404 13.1 10.4536 10.9399 10.4536 8.2029H10.2536C10.2536 10.8334 8.19965 12.9 5.68354 12.9V13.1ZM0.9 8.2029C0.9 10.9388 3.05104 13.1 5.68354 13.1V12.9C3.16479 12.9 1.1 10.8316 1.1 8.2029H0.9ZM2.17481 4.24252C1.70324 5.00405 1.38358 5.61944 1.1825 6.233C0.980983 6.84785 0.9 7.45632 0.9 8.2029H1.1C1.1 7.47225 1.17908 6.88561 1.37255 6.29529C1.56645 5.70366 1.87671 5.10381 2.34485 4.34781L2.17481 4.24252ZM3.43463 4.54576C3.36967 3.88887 2.52461 3.67762 2.17481 4.24252L2.34485 4.34781C2.58974 3.95234 3.18867 4.09084 3.2356 4.56544L3.43463 4.54576ZM3.84736 5.77232C3.63313 5.45627 3.48349 5.04 3.43463 4.54576L3.2356 4.56544C3.28726 5.08792 3.4463 5.5371 3.68181 5.88454L3.84736 5.77232ZM6.26722 0.97247C4.30381 1.95242 3.51232 4.01277 3.66493 5.83677L3.86424 5.82009C3.71688 4.05884 4.48192 2.08705 6.35653 1.15142L6.26722 0.97247ZM7.23367 1.76325C7.36726 1.19447 6.79271 0.710194 6.26722 0.97247L6.35653 1.15142C6.71961 0.970205 7.13659 1.30187 7.03897 1.71752L7.23367 1.76325ZM8.01986 4.36788C7.62258 4.00386 7.3573 3.66125 7.22428 3.2606C7.09141 2.8604 7.08648 2.38996 7.23367 1.76325L7.03897 1.71752C6.88656 2.36644 6.88617 2.87694 7.03447 3.32362C7.18262 3.76985 7.47514 4.14003 7.88475 4.51534L8.01986 4.36788ZM8.26486 4.55156C8.19828 4.50241 8.14021 4.45953 8.09632 4.42669C8.07436 4.41026 8.05627 4.39659 8.04262 4.38604C8.03579 4.38076 8.03032 4.37646 8.02618 4.37311C8.02411 4.37145 8.02252 4.37014 8.02136 4.36915C8.02012 4.36811 8.01971 4.36773 8.01986 4.36788L7.88475 4.51534C7.89924 4.52861 7.93454 4.55543 7.97651 4.58683C8.02103 4.62015 8.0797 4.66346 8.14607 4.71246L8.26486 4.55156ZM9.0247 5.13369C8.85508 4.9872 8.50393 4.72806 8.26486 4.55156L8.14607 4.71246C8.38856 4.89148 8.73168 5.14489 8.89398 5.28506L9.0247 5.13369ZM2.26921 8.20284C2.26921 7.12748 2.46307 6.67974 2.62398 6.30513L2.44022 6.2262C2.27167 6.61857 2.06921 7.09349 2.06921 8.20284H2.26921ZM5.68354 11.7022C3.80514 11.7022 2.26921 10.1645 2.26921 8.20284H2.06921C2.06921 10.2716 3.69138 11.9022 5.68354 11.9022V11.7022ZM9.08443 8.20284C9.08443 10.1675 7.55807 11.7022 5.68354 11.7022V11.9022C7.67258 11.9022 9.28443 10.2739 9.28443 8.20284H9.08443ZM8.14034 6.2007C8.76344 6.73885 9.08443 7.33509 9.08443 8.20284H9.28443C9.28443 7.27012 8.9327 6.62076 8.27107 6.04934L8.14034 6.2007ZM7.58325 5.77447C7.80891 5.94234 8.04249 6.11619 8.14034 6.2007L8.27107 6.04934C8.16612 5.95871 7.92436 5.77896 7.70262 5.614L7.58325 5.77447ZM7.10528 5.408C7.16977 5.46709 7.3752 5.61971 7.58325 5.77447L7.70262 5.614C7.48763 5.45408 7.29501 5.31059 7.24039 5.26054L7.10528 5.408ZM5.76045 2.86714C5.82692 3.9086 6.31825 4.68689 7.10528 5.408L7.24039 5.26054C6.47808 4.56207 6.02222 3.82868 5.96004 2.8544L5.76045 2.86714ZM5.17368 6.85363C4.67407 4.48358 5.5607 3.30121 5.93091 2.93153L5.78958 2.79001C5.37643 3.20259 4.46304 4.45211 4.97798 6.89488L5.17368 6.85363ZM4.5044 7.69952C4.94348 7.69952 5.2648 7.28588 5.17368 6.85363L4.97798 6.89488C5.04414 7.20873 4.81045 7.49952 4.5044 7.49952V7.69952ZM2.49863 6.17893C2.95413 7.08313 3.71234 7.69952 4.5044 7.69952V7.49952C3.81806 7.49952 3.11489 6.95771 2.67725 6.08895L2.49863 6.17893ZM2.62398 6.30513C2.64312 6.26058 2.66214 6.21629 2.68038 6.17207L2.49549 6.09581C2.4779 6.13846 2.45946 6.1814 2.44022 6.2262L2.62398 6.30513Z" fill="white"/>
            </svg>
          </div>
        </div>
    </div>
</template>

<script>

    import moment from "moment";

    export default {
        name: 'GameUserListItem',
        data: function() {
            return {
                id: this.game.id,
                dialog: false,
                submitDisabled: false,
                now_date: moment.utc(new Date()).format('X'),
                date: (this.matches.user.online) ? moment.utc(this.matches.user.online).format('X') : null,
            }
        },
        props: {
            matches: {
                type: Object,
            },
            game: {
                type: Object
            },
            user: {
                type: Object
            },
            profile: {
                type: Object
            },
            item_game: {
                type: String,
            },
            index: {
                type: Number,
            }
        },
        computed: {
            auth() {
                return this.$store.state.auth.user
            },
        },
        methods: {
            sendInvitation(userId, match_id){
                let matches= this.matches;

                const formData = {
                    match_id: match_id,
                    game_id: this.game.id,
                    user_id: userId,
                    amount: this.primNum(matches.amount, 2),
                    wallet: matches.wallet
                };
                this.$http.post('ajax/games/play_on', formData)
                    .then(response=> {
                        return response.json()
                    })
                    .then((response)=> {
                        if(this.$checkAuth(response)) {
                            response = response.data;
                            this.dialog = true;
                            // this.$emit('update:invite', this.matches);
                            this.matches.cancel = false;
                            this.matches.timestamp = response.timestamp;
                            this.$store.dispatch("asyncModalInvite", this.matches);
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
                this.submitDisabled=true;
                setTimeout(()=> {
                    this.submitDisabled= false;
                }, 15000);
            },
        },
        mounted() {

        },
        components: {

        },
    };
</script>

<style lang="scss" scoped>

.dark .user-list {
    background: #171827;

    .v-list-item {
        &__title {
            color: #fff;

            a {
                color: #fff;
            }
        }
    }
}

.dark .number-rating {
    background: #171827;
    color: #fff;

    &--first {
        background-color: #6886af;
        color: #fff;
    }
    &--second {
        background-color: #6886af;
        color: #fff;
    }
    &--third {
        background-color: #6886af;
        color: #fff;
    }
}

.dark .item_game {
    border-bottom: 1px solid #171827;
}

.dark {
    .online {
        border: 2px solid #202020;
    }
}

.online {
  border: 2px solid #fff;
  border-radius: 50%;
  background-color: #00C569;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 0;
  bottom: 2px;
}

.user-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:5px 12px 5px 5px;
  /*border-bottom: 2px solid #ECF4FF;*/
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 38.42%, rgba(255, 255, 255, 0.5) 99.34%);
  border-radius: 8px;
  margin-bottom: 10px;

  .v-list-item {

    &__title {
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-transform: capitalize;
      color: #002B50;
      margin-bottom:3px;
      max-width: 170px;
      min-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;

        a {
            text-decoration: none;
            color: #002B50;

            &:hover {
                text-decoration: underline;
                color: #4EBEFF;
            }
        }
    }

    &__subtitle {
      font-size: 12px;
      line-height: 16px;
    }
  }
}

.item_game {
    border-radius: 0;
    background-color: #fff;
    border-bottom: 1px solid #ECF4FF;
    margin-bottom: 0;
    padding: 12px 20px 7px;
}

.number-rating {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 22px 0 4px;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    color: #002B50;

    &--first {
        background-color: #002B50;
        border-radius: 50%;
        color: #fff;
        position: relative;

        &:after {
            content: '';
            position: absolute;
            top: -8px;
            left: 3px;
            display: block;
            width: 18px;
            height: 10px;
            background-image: url("/dist/images/frontend/crown-gold.svg");
        }
    }
    &--second {
        background-color: #002B50;
        border-radius: 50%;
        color: #fff;
        position: relative;

        &:after {
            content: '';
            position: absolute;
            top: -8px;
            left: 3px;
            display: block;
            width: 18px;
            height: 10px;
            background-image: url("/dist/images/frontend/crown-silver.svg");
        }
    }
    &--third {
        background-color: #002B50;
        border-radius: 50%;
        color: #fff;
        position: relative;

        &:after {
            content: '';
            position: absolute;
            top: -8px;
            left: 3px;
            display: block;
            width: 18px;
            height: 10px;
            background-image: url("/dist/images/frontend/crown-bronza.svg");
        }

    }
}

.block-img {
  margin-right: 10px;
  position: relative;

    a {
        text-decoration: none;
    }

    .wrap-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }

    .photo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        color: #FFFFFF;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        text-decoration: none;
    }
}

.block-img-game {
    margin-right: 10px;
    position: relative;

    .wrap-img-game {
        width: 54px;
        height: 54px;
        border-radius: 8px;
        box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.05);

        img {
            width: 54px;
            height: 54px;
            border-radius: 8px;
        }
    }
}

.rating {
    span {
        margin-right: 6px;
        margin-top: 3px;
        /*font-weight: bold;*/
        font-size: 14px;
        line-height: 22px;
        letter-spacing: -0.408px;
        color: #96afd1;
    }

    .v-rating {
        margin-top: 2px;

        .v-rating--dense .v-icon {
            padding: 0;
        }
    }

    a {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #26a9f4;
        text-decoration: none;
        margin-top: 7px;

        &:hover {
            text-decoration: underline;
        }
    }
}

.success-inner {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    border: 1px solid #00C443;
    box-sizing: border-box;
    border-radius: 8px;
    text-transform: inherit;
    color: #00C443;
    transition-duration: .3s;

    .pic {
        height:12px;
        margin: 0 1px 0 4px;
    }

    &:hover {
       border: 2px solid #00AD3B;
    }
}

.default-inner {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    border: 1px solid #6886AF;
    box-sizing: border-box;
    border-radius: 8px;
    text-transform: inherit;
    color: #6886AF;
    transition-duration: .3s;

    .pic {
        height:12px;
        margin: 0 1px 0 4px;
    }

     &:hover {
        border: 2px solid #96AFD1;
    }
}
.block-game-rating {
    display: flex;
    align-items: center;
    margin-right: 10px;

    span {
        font-size: 15px;
        line-height: 16px;
        letter-spacing: 0.1px;
        color: #00C443;
        margin-right: 6px;
    }
}


@media screen and (max-width: 1250px) {


    .user-list {

        .v-list-item {

            &__avatar {
                min-width: 45px;
            }

            &__title {
                font-weight: 400;
                font-size: 14px;
                line-height: 19px;
                text-transform: capitalize;
                color: #002B50;
                margin-bottom:3px;
            }

            &__subtitle {
                font-size: 12px;
                line-height: 16px;
            }
        }
    }

    .block-img {

        .wrap-img {
            width: 45px;
            height: 45px;
            border-radius: 50%;

            img {
                width: 45px;
                height: 45px;
                border-radius: 50%;
            }
        }

        .photo {
            width: 45px;
            height: 45px;
            border-radius: 50%;
        }
    }


    .block-money {
        span {
            font-size: 14px;
        }
        img {
            height: 12px;
        }
        .v-btn {
            font-size: 12px;
            margin-left: 30px;
        }
    }

    .v-btn:not(.v-btn--round).v-size--default {
        height: 36px;
        min-width: 120px;
        // width: 124px;
        padding: 10px;
    }

}

@media screen and (max-width: 650px){
    .user-list {
        .v-list-item {
            &__title {
                max-width: 150px;
                min-width: 150px;
                font-size: 13px;
                line-height: 17px;
            }

            &__subtitle {
                font-size: 11px;
                line-height: 14px;
            }
        }
    }
}

@media screen and (max-width: 525px) {

    .user-list {
        padding: 5px 10px;

        .v-list-item {
            &__title {
                max-width: 150px;
                min-width: 150px;
            }
        }

        .block-money {
            span {
                font-size: 10px;
            }

            img {
                height: 8px;
            }

            .v-btn {
                font-size: 8px;
                margin-left: 15px;
                border-radius: 6px;
            }
        }
        .v-btn:not(.v-btn--round).v-size--default {
            height: 30px;
            min-width: 90px;
            // width: 124px;
            padding: 10px;
        }

        .block-img {
            margin-right: 5px;
            .wrap-img {
                width: 40px;
                height: 40px;
                border-radius: 50%;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
            }

            .photo {
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
        }
    }
}

</style>